import { render } from "./kubevirt.io.virtualmachine.vue?vue&type=template&id=009f6744"
import script from "./kubevirt.io.virtualmachine.vue?vue&type=script&lang=js"
export * from "./kubevirt.io.virtualmachine.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__